import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

/**
 * Matsedeln finns på svenska och engelska i skolsystemet. Skolsystemet levererar
 * sv, en och es.
 */
const inputSchema = z.object({
  lang: z.enum(["sv", "en", "es"]).default("sv"),
  year: z.number().int().optional(),
  month: z.number().int().min(1).max(12).optional(),
});

export type MenuLang = "sv" | "en" | "es";

export function menuLang(lang: "sv" | "en" | "es"): MenuLang {
  return lang;
}

export const getFoodMenu = createServerFn({ method: "POST" })
  .inputValidator((data: unknown) => inputSchema.parse(data ?? {}))
  .handler(async ({ data }) => {
    const lang = menuLang(data.lang);
    const { listFoodMenus, getFoodMenuDetail } = await import("./food-menu.server");
    const [menus, detail] = await Promise.all([
      listFoodMenus(),
      getFoodMenuDetail(lang, data.year, data.month),
    ]);

    // Bygg (eller återanvänd) PDF:erna för båda språken redan när menyn läses
    // in, så att nedladdningen alltid går direkt oavsett valt språk.
    if (detail && detail.items.length > 0) {
      const { warmFoodMenuPdfs } = await import("./food-menu-pdf-cache.server");
      void warmFoodMenuPdfs(detail.menu?.year ?? data.year, detail.menu?.month ?? data.month);
    }

    return { menus, detail, lang };
  });
